// extracted by mini-css-extract-plugin
export default {"title":"PersonalizationSummaryPublicPage_title__a4yMN"};